import { httpApi } from './http';

export type GmailConnection = {
  _id?: string;
  userId?: string;
  email?: string;
  status?: string;
  scopes?: string[];
  createdAt?: string;
  updatedAt?: string;
};

export async function getGmailOAuthUrl(): Promise<string> {
  const redirectUri = `${window.location.origin}/gmail/callback`;
  const response = await httpApi.get('/gmail/oauth/url', { params: { redirectUri } });
  return (response.data as any).url as string;
}

export async function exchangeGmailOAuthCode(params: {
  code: string;
  state: string;
  redirectUri: string;
}) {
  const response = await httpApi.post('/gmail/oauth/exchange', params);
  return response.data;
}

export async function getGmailConnection(): Promise<GmailConnection | null> {
  try {
    const response = await httpApi.get('/gmail/connection');
    return (response.data as any).connection as GmailConnection;
  } catch (e: any) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

export async function disconnectGmail() {
  const response = await httpApi.delete('/gmail/connection');
  return response.data;
}
